<template>
  <v-container text-xs-center>
    <!--Stat cards -->
    <v-row v-if="canSee('presentCheckinAdminDiv') && $mq != 'mobile'">
      <v-col cols="12" xs="12" sm="12" md="12">
        <v-row wrap>
          <v-flex xs12 sm4 md4 style="padding: 5px">
            <v-card color="primary" dark>
              <v-card-title>
                <v-spacer></v-spacer>
                <i class="material-icons" style="font-size: 39px;">supervised_user_circle</i>
              </v-card-title>
              <v-container fill-height>
                <v-layout align-center pa-5 ma-2 elevation="5">
                  <strong
                    class="display-4 font-weight-regular mr-4"
                  >{{ getTotalPresentTodayCount() }}</strong>
                  <v-layout column justify-end style="margin-bottom: auto !important;">
                    <div class="headline font-weight-medium">Present</div>
                    <div class="text-uppercase font-weight-light">Today</div>
                  </v-layout>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>

          <v-flex xs12 sm4 md4 style="padding: 5px">
            <v-card color="primary" dark>
              <v-card-title>
                <v-spacer></v-spacer>
                <i class="material-icons" style="font-size: 39px;">supervised_user_circle</i>
              </v-card-title>
              <v-container fill-height>
                <v-layout align-center pa-5 ma-2>
                  <strong class="display-4 font-weight-regular mr-4">{{ getCheckedInCount() }}</strong>
                  <v-layout column justify-end style="margin-bottom: auto !important;">
                    <div class="headline font-weight-medium">Checked In</div>
                    <div class="text-uppercase font-weight-light">NOW</div>
                  </v-layout>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>

          <v-flex xs12 sm4 md4 style="padding: 5px">
            <v-card color="primary" dark>
              <v-card-title>
                <v-spacer></v-spacer>
                <div>
                  <img
                    v-bind:src="defaultImage"
                    height="30"
                    style="width: 30px; border-radius: 50px;"
                  />
                </div>
              </v-card-title>
              <v-container>
                <v-layout align-center pa-5 ma-2>
                  <strong class="display-4 font-weight-regular mr-4">{{ presentThisMonthCount }}</strong>
                  <v-layout column justify-end style="margin-bottom: auto !important;">
                    <div class="headline font-weight-medium">Days Present</div>
                    <div class="text-uppercase font-weight-light">{{ $moment().format("MMMM") }}</div>
                  </v-layout>
                </v-layout>
              </v-container>
            </v-card>
          </v-flex>
        </v-row>
      </v-col>
    </v-row>

    <v-row style="padding: 5px">
      <v-col class="col-12" sm12 md12 style="padding: 0px">
        <v-card
          v-if="canSee('presentCheckinAdminDiv') && $mq == 'mobile'"
          color="primary"
          dark
          style="padding: 0px"
        >
          <v-card-text style="padding: 0px">
            <v-window v-model="onboarding" reverse>
              <v-window-item>
                <v-flex xs12 sm4 md4 style="padding: 5px;">
                  <v-card
                    v-touch="{ left: () => swipe('Left'), right: () => swipe('Right') }"
                    style="background-color: transparent;"
                    elevation="0"
                  >
                    <v-card-title>
                      <v-spacer></v-spacer>
                      <i class="material-icons" style="font-size: 28px;">supervised_user_circle</i>
                    </v-card-title>
                    <v-container fill-height>
                      <v-layout align-center pa-3 ma-2>
                        <strong
                          class="display-3 font-weight-regular mr-3"
                        >{{ getTotalPresentTodayCount() }}</strong>
                        <v-layout column justify-end style="margin-bottom: auto !important;">
                          <div class="headline font-weight-medium">Present</div>
                          <div class="text-uppercase font-weight-light">Today</div>
                        </v-layout>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>
              </v-window-item>

              <v-window-item>
                <v-flex xs12 sm4 md4 style="padding: 5px">
                  <v-card
                    v-touch="{ left: () => swipe('Left'), right: () => swipe('Right') }"
                    elevation="0"
                    style="background-color: transparent"
                  >
                    <v-card-title>
                      <v-spacer></v-spacer>
                      <i class="material-icons" style="font-size: 28px;">supervised_user_circle</i>
                    </v-card-title>
                    <v-container fill-height>
                      <v-layout align-center pa-3 ma-2>
                        <strong class="display-3 font-weight-regular mr-3">{{ getCheckedInCount() }}</strong>
                        <v-layout column justify-end style="margin-bottom: auto !important;">
                          <div class="headline font-weight-medium">Checked In</div>
                          <div class="text-uppercase font-weight-light">NOW</div>
                        </v-layout>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>
              </v-window-item>

              <v-window-item>
                <v-flex xs12 sm4 md4 style="padding: 5px">
                  <v-card
                    v-touch="{ left: () => swipe('Left'), right: () => swipe('Right') }"
                    elevation="0"
                    style="background-color: transparent"
                  >
                    <v-card-title>
                      <v-spacer></v-spacer>
                      <div>
                        <img
                          v-bind:src="defaultImage"
                          height="34"
                          style="width: 34px; border-radius: 50px;"
                        />
                      </div>
                    </v-card-title>
                    <v-container fill-height>
                      <v-layout align-center pa-2 ma-1>
                        <strong
                          class="display-3 font-weight-regular mr-3"
                        >{{ presentThisMonthCount }}</strong>
                        <v-layout column justify-end style="margin-bottom: auto !important;">
                          <div class="headline font-weight-medium">Days Present</div>
                          <div
                            class="text-uppercase font-weight-light"
                          >{{ $moment().format("MMMM") }}</div>
                        </v-layout>
                      </v-layout>
                    </v-container>
                  </v-card>
                </v-flex>
              </v-window-item>
            </v-window>
          </v-card-text>
          <v-card-actions style="padding: 0px">
            <v-flex
              xs12
              sm8
              offset-sm2
              md8
              offset-md2
              style="margin-top: 5px; margin-bottom: 5px; text-align: center"
            >
              <v-item-group v-model="onboarding" class="text-xs-center">
                <v-item v-for="n in length" :key="`btn-${n}`">
                  <v-btn
                    slot-scope="{ active, toggle }"
                    :input-value="active"
                    @click="toggle"
                    icon
                    text
                    small
                  >
                    <v-icon small>mdi-record</v-icon>
                  </v-btn>
                </v-item>
              </v-item-group>
            </v-flex>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-row v-if="canSee('presentCheckinUserDiv')" wrap>
      <v-col xs="12" sm="12" md="12">
        <v-flex xs12 sm12 md12>
          <v-card color="primary" dark>
            <v-container>
              <v-layout align-center pa-5 ma-2>
                <strong class="display-4 font-weight-regular mr-4">{{ presentThisMonthCount }}</strong>
                <v-layout column justify-end style="margin-bottom: auto !important;">
                  <div class="headline font-weight-medium">Days Present</div>
                  <div class="text-uppercase font-weight-light">This month</div>
                </v-layout>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-col>
    </v-row>

    <!-- Timeline card view -->
    <!-- <v-col cols="12" xs="12" sm="12" md="12" style="padding: 0px"> -->
    <v-row style="padding: 5px">
      <v-tabs
        fixed-tabs
        background-color="primary"
        dark
        style="margin: 10px 0px; border-radius: 3px"
      >
        <v-tab>Dashboard</v-tab>
        <v-tab v-if="$store.getters.userDetails.role.toLowerCase() != 'user'">Team</v-tab>

        <v-tab-item>
          <v-card>
            <v-card-text style="padding: 5px 25px">
              <v-card elevation="0" style="border-radius: 2px">
                <v-card-text>
                  <v-timeline
                    v-if="userLastPunchs.length > 0"
                    :dense="$vuetify.breakpoint.smAndDown"
                    reverse
                  >
                    <v-timeline-item
                      v-for="item in userLastPunchs"
                      :key="item.id"
                      :color="item.punchType == 'IN' ? 'success' : 'error'"
                      large
                      fill-dot
                    >
                      <template v-slot:icon>
                        <v-avatar v-if="item.image">
                          <v-img :src="getImage(item.image, true)" @click="zoom(item.image)"></v-img>
                        </v-avatar>
                        <v-avatar v-else>
                          <v-icon color="white">face</v-icon>
                        </v-avatar>
                      </template>

                      <template v-slot:opposite>
                        <v-chip
                          :color="colorCalc(item.punchType)"
                          class="white--text"
                          label
                          small
                          align-right
                        >{{ item.punchType }}</v-chip>
                      </template>

                      <div class="py-4" style="text-align: center">
                        <h2
                          class="headline font-weight-light mb-4"
                        >{{ item.time | moment("timezone", item.timezone.name, "h:mm a") }}</h2>
                        <div>
                          {{ item.time | moment("timezone", item.timezone.name, " Do MMM z") }}
                          at {{ item.originalLocation.name }}
                        </div>
                      </div>
                    </v-timeline-item>
                  </v-timeline>
                  <div v-else align="center">
                    <v-nodata
                      :loading="loading.lastPunch"
                      :networkError="networkError.lastPunch"
                      @retryMethod="getUserPunchs"
                      title
                      msg-details="Waiting for punches"
                      icon="checkinguy"
                    ></v-nodata>
                  </div>
                </v-card-text>
              </v-card>
            </v-card-text>
          </v-card>
        </v-tab-item>

        <v-tab-item v-if="$store.getters.userDetails.role.toLowerCase() != 'user'">
          <v-card>
            <v-card-text style="padding: 5px 15px">
              <v-row>
                <v-col xs="12" sm="12" md="12">
                  <v-text-field
                    v-model="search"
                    @input="searchContents"
                    prepend-icon="search"
                    label="Search"
                  ></v-text-field>
                </v-col>
              </v-row>

              <TimelineCard
                :show="!renderComponent && loading.latestCheckinError"
                :renderedData="timelinePunchDetails"
                @zoom="zoom"
              ></TimelineCard>
            </v-card-text>
          </v-card>
        </v-tab-item>
      </v-tabs>
    </v-row>

    <!-- start of submit form dialog -->
    <v-dialog v-model="showAllFormsDialog" width="300" persistent>
      <v-card
        v-if="showUserForms.length > 0"
        style="border-radius: 2px;min-height:300px;"
        elevation="1"
      >
        <v-card-title
          class="primary"
          style="color: #fafafa; letter-spacing: 0.5px; font-weight: 500"
        >
          <v-layout row>
            <v-flex xs8 md8 sm8 style="text-align: left">
              <h4 style="font-weight: 500">Select Form</h4>
            </v-flex>
            <v-flex xs4 md4 sm4 style="text-align: right; margin-top: -5px">
              <v-btn @click="showAllFormsDialog = false" text elevation="0" fab small>
                <v-icon style="color: #fff">close</v-icon>
              </v-btn>
            </v-flex>

            <v-flex xs12 sm12 md12 style="margin-top: 7px">
              <v-text-field
                @input="searchInDialog($event, 'form')"
                prepend-inner-icon="search"
                label="Search"
                solo
                dense
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-divider></v-divider>
        <v-card-text style="padding: 2px">
          <div v-if="searchFormLists.length > 0">
            <v-list two-line>
              <v-list-item v-for="item in searchFormLists" :key="item.id" avatar>
                <v-list-item-avatar>
                  <v-icon class="blue lighten-1 white--text">assignment</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                  <v-list-item-subtitle>{{ item.desc }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-btn @click="selectedForm(item)" icon ripple>
                  <v-icon big>arrow_forward</v-icon>
                </v-btn>
              </v-list-item>
            </v-list>
          </div>
          <div v-else>
            <v-card elevation="0" color="transparent" style="text-align: center">
              <v-icon :size="50" style="opacity: 0.5;padding-top: 8%;">speaker_notes_off</v-icon>
              <h3
                style="font-size: 13px; letter-spacing: 0.5px; font-weight: 400; opacity: 0.7; margin-top: 6px; margin-bottom: 6px"
              >No forms found</h3>
            </v-card>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of submit form dialog -->

    <v-dialog v-model="dialog" max-width="300" persistent>
      <v-card
        v-if="generateLocationList.length > 0"
        style="border-radius: 2px;min-height:300px;"
        elevation="1"
      >
        <v-card-title
          class="primary"
          style="color: #fafafa; letter-spacing: 0.5px; font-weight: 500"
        >
          <v-layout row>
            <v-flex xs8 md8 sm8 style="text-align: left">
              <h4 style="font-weight: 500">Select Location</h4>
            </v-flex>
            <v-flex xs4 md4 sm4 style="text-align: right; margin-top: -5px">
              <v-btn @click="dialog = false" text elevation="0" fab small>
                <v-icon style="color: #fff">close</v-icon>
              </v-btn>
            </v-flex>

            <v-flex xs12 sm12 md12 style="margin-top: 7px">
              <v-text-field
                @input="searchInDialog($event, 'location')"
                prepend-inner-icon="search"
                label="Search"
                solo
                dense
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-divider></v-divider>
        <v-card-text style="padding: 2px">
          <div v-if="searchLocationLists.length > 0">
            <v-list two-line>
              <v-list-item
                @click="performPunch(item)"
                v-for="item in searchLocationLists"
                :key="item"
                avatar
                two-line
              >
                <v-list-item-avatar>
                  <v-icon class="blue lighten-1 white--text">location_on</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ getLocationName(item) }}</v-list-item-title>
                  <v-list-item-subtitle>{{ getLocationDesc(item) }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
          <div v-else>
            <v-card elevation="0" color="transparent" style="text-align: center">
              <v-icon :size="50" style="opacity: 0.5;padding-top: 8%;">location_off</v-icon>
              <h3
                style="font-size: 13px; letter-spacing: 0.5px; font-weight: 400; opacity: 0.7; margin-top: 6px; margin-bottom: 6px"
              >No locations found</h3>
            </v-card>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogFormSelected" max-width="400">
      <v-card>
        <v-form ref="form">
          <v-card-title
            class="primary"
            style="color: #fafafa; letter-spacing: 0.5px; font-weight: 500"
          >
            <h4>Form Submission</h4>
          </v-card-title>

          <v-divider></v-divider>

          <v-card-text
            v-for="(itemdataForm, index) in userSelectedFormData"
            :key="itemdataForm.placeHolder"
            avatar
          >
            <h4
              style="font-size: 14px; letter-spacing: 1px; font-weight: bold; margin-bottom: 10px;"
            >
              {{ itemdataForm.placeHolder }}
              <span v-if="itemdataForm.required">*</span>
            </h4>

            <h4 v-if="itemdataForm.fieldType == 'boolean'">
              <v-radio-group
                :rules="[checkIfRequired(itemdataForm.required, itemdataForm.answer)]"
                v-model="itemdataForm.answer"
              >
                <v-radio label="Yes" value="Yes"></v-radio>
                <v-radio label="No" value="No"></v-radio>
              </v-radio-group>
            </h4>

            <h4 v-if="itemdataForm.fieldType == 'text'">
              <v-text-field
                :rules="[checkIfRequired(itemdataForm.required, itemdataForm.answer)]"
                v-model="itemdataForm.answer"
                label="Answer"
                placeholder="Submit your answer"
                required
                style="font-size: 14px; font-weight: 400"
              ></v-text-field>
            </h4>

            <h4 v-if="itemdataForm.fieldType == 'number'">
              <v-text-field
                :rules="[checkIfRequired(itemdataForm.required, itemdataForm.answer)]"
                v-model="itemdataForm.answer"
                label="Answer"
                placeholder="Submit your answer"
                required
                type="Number"
                style="font-size: 14px; font-weight: 400"
              ></v-text-field>
            </h4>

            <h4 v-if="itemdataForm.fieldType == 'date'">
              <!-- <date-picker
                v-model="itemdataForm.answer"
                :rules="[checkIfRequired(itemdataForm.required, itemdataForm.answer)]"
                type="datetime"
                lang="en"
                format="YYYY-MM-DD HH:mm:ss"
                confirm
              ></date-picker>-->

              <v-datetime-picker
                v-model="itemdataForm.answer"
                :rules="[checkIfRequired(itemdataForm.required, itemdataForm.answer)]"
                label="Select Datetime"
                time-format="HH:mm:ss"
              ></v-datetime-picker>
            </h4>

            <h4 v-if="itemdataForm.fieldType == 'option'">
              <v-autocomplete
                v-model="itemdataForm.answer"
                :items="itemdataForm.options"
                :rules="[checkIfRequired(itemdataForm.required, itemdataForm.answer)]"
                outlined
                chips
                small-chips
                label="Select Option"
              ></v-autocomplete>
            </h4>

            <h4 v-if="itemdataForm.fieldType == 'checkbox'">
              <v-autocomplete
                v-model="itemdataForm.answer"
                :items="itemdataForm.options"
                :rules="[checkIfRequired(itemdataForm.required, itemdataForm.answer)]"
                outlined
                chips
                small-chips
                multiple
                label="Choose Options"
              ></v-autocomplete>
            </h4>

            <!-- itemdataForm.placeHolder -->
            <h6 v-if="itemdataForm.fieldType == 'attachment'" style="text-align: center">
              <v-card class="attachment_card">
                <input
                  :id="`attachment_${index}`"
                  :rules="[checkIfRequired(itemdataForm.required, itemdataForm.answer)]"
                  :ref="`attachment_${index}`"
                  v-on:input="handleFilesUpload(index, $event, `attachment_${index}`)"
                  type="file"
                  hidden
                  accept="`image/jpeg, image/pjpeg, image/gif, image/png, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.wordprocessingml.template, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.openxmlformats-officedocument.presentationml.presentation, application/pdf, text/plain, application/vnd.ms-excel, text/csv, application/msword`"
                />
                <h5 style="font-size: 13px; margin-top: 5px;" else>{{ attachmentName[index] }}</h5>
                <div style="text-align: center">
                  <v-btn
                    @click.native="selectFile(`attachment_${index}`, index)"
                    v-if="!userSelectedFormData[index].answer.name"
                    class="primary"
                  >Select file</v-btn>
                  <v-btn
                    v-on:click="removeFile(index)"
                    v-else
                    class="error remove_attachment"
                  >Remove</v-btn>
                </div>
              </v-card>
            </h6>

            <h6 v-if="itemdataForm.fieldType == 'attachmentCapture'" style="text-align: center">
              <v-card class="attachment_card">
                <h5 v-if="capturedImage != ''" style="font-size: 13px; margin-top: 5px;">
                  <img :src="capturedImage" style="height:80px;" />
                </h5>
                <div style="text-align: center">
                  <v-btn
                    @click="captureImage"
                    v-if="capturedImage == ''"
                    class="primary"
                  >Take Picture</v-btn>
                  <v-btn
                    v-on:click="capturedImage = ''"
                    v-else
                    class="error remove_attachment"
                  >Remove</v-btn>
                </div>
              </v-card>
            </h6>

            <h6
              v-if="itemdataForm.fieldType == 'attachmentSignature'"
              style="text-align: center;outline: 1px solid black;"
            >
              <div>
                <VueSignaturePad ref="signaturePad" :options="{ onBegin }" height="300px" />
                <div>
                  <div style="text-align: center;padding: 6px;">
                    <!-- <v-btn class="primary">Save</v-btn> -->
                    <v-btn @click="undoSign" class="error" style="margin-left: 4px;">Clear</v-btn>
                  </div>
                </div>
              </div>
            </h6>
          </v-card-text>

          <div style="min-height:26px;"></div>

          <div style="padding:10px!important,margin-top:12%!important;">
            <v-card-actions style="padding:10px!important,margin-top:12%!important;">
              <v-spacer></v-spacer>
              <v-btn @click="closeFormDialog" text>Cancel</v-btn>
              <v-btn
                :disabled="afterSubmit"
                @click="formsDataPost"
                color="primary"
                class="white--text"
              >Submit</v-btn>
            </v-card-actions>
          </div>
        </v-form>
      </v-card>
    </v-dialog>

    <!-- Form Dialog -->
    <v-dialog v-model="dialogFormResponse" max-width="700px">
      <v-card style="padding: 0px 10px; border-radius: 2px">
        <v-card-title>
          <h3 class="form_response_title_h3">User: {{ getName(responseForm.userId) }}</h3>
        </v-card-title>

        <v-divider style="margin-bottom: 5px;"></v-divider>

        <v-card-text style="padding: 10px">
          <v-row wrap>
            <v-col
              v-for="question in responseForm.response"
              :key="question.id"
              xs12
              sm6
              style="margin-top: 5px; margin-bottom: 5px;"
            >
              <h3 class="form_response_h3">Question: {{ question.placeHolder }}</h3>

              <h4 v-if="question.fieldType == 'attachment'" class="form_response_h4">
                Answer:
                <a
                  :download="question.answer"
                  :href="getAttachment(question.answer)"
                  v-if="question.answer"
                  target="_blank"
                >Download</a>
              </h4>

              <h4 v-else class="form_response_h4">Answer: {{ question.answer }}</h4>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="dialogFormResponse = false" color="primary">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogZoom" max-width="40vw" content-class="reg__boxShadowHide">
      <img :src="selectedZoomImage" @click.stop="dialogZoom = false" />
    </v-dialog>

    <v-snackbar v-model="punchBar" :bottom="'bottom'" :timeout="Number(0)">
      {{ punchBarText }}
      <!--<v-btn color="pink" @click="stopPunch()">CANCEL</v-btn> -->
    </v-snackbar>

    <!-- same dialogs starts from here  -->
    <v-dialog v-model="fieldTrackingFormsDialog" max-width="300" no-click-animation persistent>
      <v-card>
        <!-- <v-card-title class="primary">
          <h3 class="reg__heading" style="margin-top: 0px">Select Form</h3>
          <v-spacer></v-spacer>
          <div class="text-xs-right">
            <v-btn icon dark black @click="fieldTrackingFormsDialog = false">
              <v-icon color="black">close</v-icon>
            </v-btn>
          </div>
        </v-card-title>-->

        <v-card-title
          class="primary"
          style="color: #fafafa; letter-spacing: 0.5px; font-weight: 500"
        >
          <v-layout row>
            <v-flex xs8 md8 sm8 style="text-align: left">
              <h4 style="font-weight: 500">Select Form</h4>
            </v-flex>
            <v-flex xs4 md4 sm4 style="text-align: right; margin-top: -5px">
              <v-btn @click="fieldTrackingFormsDialog = false" text elevation="0" fab small>
                <v-icon style="color: #fff">close</v-icon>
              </v-btn>
            </v-flex>

            <v-flex xs12 sm12 md12 style="margin-top: 7px">
              <v-text-field
                @input="searchInDialog($event, 'fieldForm')"
                prepend-inner-icon="search"
                label="Search"
                solo
                dense
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-title>

        <v-card-text style="padding:0px">
          <div v-if="searchFieldFormLists.length > 0">
            <v-list two-line subheader>
              <v-list-item
                v-for="item in searchFieldFormLists"
                :key="item.id"
                @click="selectedForm(item)"
                avatar
              >
                <v-list-item-avatar>
                  <v-icon class="blue lighten-1 white--text">insert_drive_file</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ item.name }}</v-list-item-title>
                  <v-list-item-sub-title>{{ item.desc }}</v-list-item-sub-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </div>
          <div v-else>
            <v-card elevation="0" color="transparent" style="text-align: center">
              <v-icon :size="50" style="opacity: 0.5;padding-top: 8%;">speaker_notes_off</v-icon>
              <h3
                style="font-size: 13px; letter-spacing: 0.5px; font-weight: 400; opacity: 0.7; margin-top: 6px; padding: 20px;"
              >No forms found</h3>
            </v-card>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="huddleDialog" max-width="500" persistant>
      <v-card>
        <v-card-title class="primary white--text">
          Start Huddle
          <v-spacer></v-spacer>
          <v-btn @click="huddleDialog = false" text elevation="0" fab small>
            <v-icon style="color: #fff">close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text style="padding: 15px 10px ">
          <div v-if="allUsers.length > 0">
            <v-autocomplete
              :items="huddleUserData"
              v-model="selectHuddleIds"
              @input="selectedHuddles($event)"
              prepend-icon="supervisor_account"
              label="Select Users"
              item-text="name"
              item-value="id"
              required
              chips
              outlined
              multiple
              dense
            ></v-autocomplete>
          </div>
          <div v-else>
            <v-card elevation="0" color="transparent" style="text-align: center">
              <v-icon :size="50" style="opacity: 0.5;padding-top: 8%;">speaker_notes_off</v-icon>
              <h3
                style="font-size: 13px; letter-spacing: 0.5px; font-weight: 400; opacity: 0.7; margin-top: 6px; padding: 20px;"
              >No Users Found</h3>
            </v-card>
          </div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="startHuddle" color="success">Start</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- same dialogs but different model name  -->

    <div>
      <!-- floating button -->
      <v-speed-dial
        v-model="menu_btn"
        v-show="
          $store.getters.userDetails.fieldTrackingSettings.enabled == true ||
            showUserForms.length > 0 ||
            $store.getters.userDetails.role == 'SuperAdmin' ||
            ($store.getters.userDetails.role == 'Admin' && canSee('allowHuddle'))
        "
        fixed
        bottom
        right
        fab
        direction="top"
      >
        <template v-slot:activator>
          <!-- <v-badge top> -->
          <v-btn v-model="menu_btn" left color="primary" light fab>
            <v-icon v-if="menu_btn">mdi-close</v-icon>
            <v-icon v-else>add</v-icon>
          </v-btn>
          <!-- </v-badge> -->
        </template>

        <v-btn
          @click="markLocation"
          v-if="$store.getters.userDetails.fieldTrackingSettings.enabled == true"
          small
          right
          class="custom_action"
          color="orange"
        >Mark Location</v-btn>
        <v-btn
          v-if="showUserForms.length > 0"
          @click="showAllFormsDialog = true"
          small
          right
          class="custom_action"
          color="primary"
        >Submit Form</v-btn>

        <v-btn
          v-if="
            $store.getters.userDetails.role == 'SuperAdmin' ||
              ($store.getters.userDetails.role == 'Admin' && canSee('allowHuddle'))
          "
          @click="huddleDialog = true"
          small
          right
          class="custom_action"
          color="primary"
        >Start Huddle</v-btn>

        <div v-if="$store.state.userDetails.realtimeFieldTrackingSettings.enabled">
          <div v-if="isMobile">
            <v-btn
              v-if="fieldTrackingEnabled == 'loading'"
              small
              right
              class="custom_action"
              color="error"
            >
              <v-progress-circular :size="18" indeterminate color="white"></v-progress-circular>
            </v-btn>
            <v-btn
              v-else-if="fieldTrackingEnabled == false"
              @click="startFieldTracking"
              small
              right
              class="custom_action"
              color="green"
            >Start Track</v-btn>
            <v-btn
              v-else-if="fieldTrackingEnabled == true"
              @click="stopFieldTracking"
              small
              right
              class="custom_action"
              color="error"
            >Stop Track</v-btn>
          </div>
        </div>
        <!-- <v-btn small right class="custom_action" color="green">Start Track
      </v-btn>
      <v-btn small right class="custom_action" color="error">Stop Track 
        </v-btn>-->
      </v-speed-dial>

      <v-btn
        v-show="!loading.lastPunch"
        :class="
          $store.getters.userDetails.fieldTrackingSettings.enabled == true ||
          showUserForms.length > 0 ||
          $store.getters.userDetails.role == 'SuperAdmin' ||
          ($store.getters.userDetails.role == 'Admin' && canSee('allowHuddle'))
            ? 'v-btn--example'
            : ''
        "
        v-if="!isCheckedIn"
        @click="punch('IN')"
        fixed
        fab
        dark
        bottom
        right
        color="green"
      >IN</v-btn>

      <v-btn
        v-else
        v-show="!loading.lastPunch"
        :class="
          $store.getters.userDetails.fieldTrackingSettings.enabled == true ||
          showUserForms.length > 0 ||
          $store.getters.userDetails.role == 'SuperAdmin' ||
          ($store.getters.userDetails.role == 'Admin' && canSee('allowHuddle'))
            ? 'v-btn--example'
            : ''
        "
        @click="punch('OUT')"
        fixed
        fab
        dark
        bottom
        right
        color="red"
      >OUT</v-btn>
    </div>

    <!-- end of button -->
  </v-container>
</template>

<script>
import fieldTracking from "@/utilities/fieldTracking";
import Avatar from "vue-avatar-component";

import moment from "moment-timezone";
import punch from "@/utilities/punch";
import _ from "lodash";
import { EventBus } from "@/utilities/event-bus.js";
import VWidget from "@/components/VWidget.vue";
import VCircle from "@/components/circle/VCircle.js";
import VNodata from "@/components/Unavailable/nodata.vue";
import canSee from "@/utilities/canSee";
import TimelineCard from "@/components/timeline_card/timeline_card";
import { firebaseDB } from "@/utilities/firebase";
import camera from "@/utilities/camera";
import DatePicker from "vue2-datepicker";
//import "vue2-datepicker/index.css";

import huddle from "@/utilities/huddle";
//console.log(DatePicker)

export default {
  name: "MySignaturePad",
  components: {
    VWidget,
    VCircle,
    VNodata,
    Avatar,
    TimelineCard,
    DatePicker
  },
  data() {
    return {
      huddleUserData: [],
      selectHuddleIds: [],
      huddleDialog: false,
      selectedFormTime: "",
      capturedImage: "",
      timelinePunchDetails: [],
      onboarding: 0,
      length: 3,
      showAllFormsDialog: false,
      renderComponent: false,
      search: "",
      menu_btn: false,
      selectedZoomImage: "",
      dialogZoom: false,
      fieldTrackingFormsDialog: false,
      presentThisMonthCount: 0,
      tab: null,
      afterSubmit: false,
      options: {
        dataLabels: {
          enabled: false
        },
        legend: {
          show: false
        },
        chart: {
          legend: {
            show: false
          },
          width: "100%",
          sparkline: {
            enabled: true
          },
          id: "vuechart-example"
        },
        xaxis: {
          categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998]
        },
        stroke: {
          curve: "straight"
        },
        fill: {
          opacity: 0.3
        },
        xaxis: {
          crosshairs: {
            width: 1
          }
        },
        yaxis: {
          min: 0
        }
      },
      series: [
        {
          name: "series-1",
          data: [30, 40, 45, 50, 49, 60, 70, 91]
        }
      ],
      attachmentName: [],
      //isMobile : true,
      chipsTag: [],
      selectedTags: [],
      punchType: "",
      users: [],
      isCheckedIn: false,
      punchBar: false,
      punchBarText: "",
      fieldTrackingEnabled: "loading",
      isFieldTrackingForm: false,
      trackingResponseData: {},
      editedIndex: -1,
      editedItem: {},
      locationList: [],
      allUsers: [],
      presentCount: {},
      punchDetails: [],
      feildtrackingForms: [],
      punchLocationId: "",
      baseLocationId: "",
      generateLocationList: [],
      userLastPunchs: [],
      punchData: [],
      forms: [],
      dialog: false,
      dialogFormSelected: false,
      formHasAttachment: false,
      selectFormID: "",
      showUserForms: [],
      watcherInterval: null,
      userSelectedFormData: [],
      shifts: [],
      fieldUserData: [],
      noFieldData: false,
      dialogFormResponse: false,
      responseForm: "",
      unsub: () => {},
      networkError: {
        fieldTracking: false,
        lastPunch: false,
        latestCheckinError: false,
        userFormError: false,
        fieldTrackingError: false
      },

      loading: {
        fieldTracking: true,
        lastPunch: true,
        latestCheckinError: true,
        userFormError: true,
        fieldTrackingError: true
      },
      fieldItem: {
        coordinates: {
          lat: 0.0,
          lng: 0.0
        }
      },
      headers: [
        {
          text: "Name",
          align: "left",
          sortable: true,
          value: "name"
        },
        {
          text: "Time",
          align: "left",
          value: "inTime"
        },
        {
          text: "In/Out",
          align: "left",
          value: "outTime"
        },
        {
          text: "Location",
          align: "left",
          value: "locationName"
        }
      ],
      headersFieldTracking: [
        {
          text: "Time",
          align: "left",
          value: "time",
          sortable: false
        },
        {
          text: "Address",
          align: "left",
          value: "gps",
          sortable: false
        },
        // { text: 'Forms',align: 'left', value: 'formResponseId', sortable: false}
        {
          text: "",
          align: "left",
          value: "",
          sortable: false
        }
      ],
      punchDetailsFieldTracking: [],
      searchFieldtracking: "",
      // for search functionality
      searchLocationLists: [],
      searchFormLists: [],
      searchFieldFormLists: []
    };
  },
  computed: {
    userDetails() {
      return this.$store.getters.userDetails;
    },
    defaultImage() {
      function getImageAttachment(src, self) {
        if (src == undefined || src == "") {
          const demoImg = require("@/assets/demo.png");
          return demoImg;
        }
        return (
          self.$store.state.imagePath +
          src.insert(src.lastIndexOf("."), "_200x200")
        );
      }
      return getImageAttachment(this.$store.getters.profilePicture, this);
    },
    isMobile() {
      try {
        return device.platform != "browser";
      } catch (e) {
        return false;
      }
    },

    pagination: {
      get: function() {
        if (this.$store.getters.pagination) {
          return this.$store.getters.pagination[this.$router.currentRoute.name];
        }
        //return 0
      },
      set: function(val) {
        this.$store.commit("setPagination", {
          name: this.$router.currentRoute.name,
          pagination: val
        });
      }
    }
  },
  beforeDestroy() {
    this.unsub();
    this.watcherInterval = null;
  },

  async created() {
    // console.log((this.$store.getters.userDetails.role == 'Admin',  canSee('allowHuddle')))
    await this.load();
    this.locationDetails();

    setInterval(() => {
      if (++this.onboarding >= this.length) this.onboarding = 0;
    }, 10000);

    this.watcherInterval = setInterval(this.updateCheckBtn, 5000);

    this.updateCheckBtn();

    firebaseDB
      .ref(
        `attendanceupdate/${this.$store.state.userDetails.companyId}/${this.$store.state.userDetails.id}`
      )
      .off();
    firebaseDB
      .ref(
        `attendanceupdate/${this.$store.state.userDetails.companyId}/${this.$store.state.userDetails.id}`
      )
      .on("value", snapshot => {
        this.getUserPunchs().then(() => {
          this.updateCheckBtn();
        });
      });

    var allObj = {
      id: "all",
      name: "All "
    };

    this.huddleUserData = this.allUsers;

    this.huddleUserData.unshift(allObj);
  },
  methods: {
    selectedHuddles(ids) {
      var totalUsers = _.map(this.huddleUserData, "id");

      if (_.includes(ids, "all")) {
        this.selectHuddleIds = totalUsers;

        totalUsers = _.without(totalUsers, "all");

        if (ids.length === totalUsers.length) {
          ids = _.without(ids, "all");
          this.selectHuddleIds = ids;
        }

        return this.selectHuddleIds;
      } else {
        if (ids.length == totalUsers.length - 1) {
          ids.unshift("all");
          this.selectHuddleIds = ids;
          return this.selectHuddleIds;
        }
        return (this.selectHuddleIds = ids);
      }
    },

    async startHuddle() {
      this.huddleDialog = false;

      this.selectHuddleIds = _.without(this.selectHuddleIds, "all");
      var response = await this.$http.post(
        `${this.$store.state.endpoint}companies/starthuddle`,
        {
          userIds: this.selectHuddleIds
        }
      );
      var huddleData = response.body;

      huddle.start(huddleData.url, huddleData.room, this.$store.state.userDetails.firstName , this.$store.state.userDetails.email);
    },

    searchInDialog(e, which) {
      const self = this;
      try {
        var search = new RegExp(e.toLowerCase(), "g"); //searched item

        var filteredData;

        if (which == "location") {
          if (e != "") {
            filteredData = _.filter(self.generateLocationList, d => {
              return (
                self
                  .getLocationName(d)
                  .toLowerCase()
                  .match(search) ||
                self
                  .getLocationDesc(d)
                  .toLowerCase()
                  .match(search)
              );
            });

            self.searchLocationLists = filteredData;
          } else {
            self.searchLocationLists = self.generateLocationList;
          }
        } else if (which == "form") {
          if (e != "") {
            filteredData = _.filter(self.showUserForms, d => {
              console.log(d);
              if (d.name.toLowerCase().match(search)) {
                return true;
              }
              if ("desc" in d) {
                if (d.desc.toLowerCase().match(search)) {
                  return true;
                }
              } else {
                return "";
              }
            });

            self.searchFormLists = filteredData;
          } else {
            self.searchFormLists = self.showUserForms;
          }
        } else if (which == "fieldForm") {
          if (e != "") {
            filteredData = _.filter(self.feildtrackingForms, d => {
              if (d.name.toLowerCase().match(search)) {
                return true;
              }
              if ("desc" in d) {
                if (d.desc.toLowerCase().match(search)) {
                  return true;
                }
              } else {
                return "";
              }
            });

            self.searchFieldFormLists = filteredData;
          } else {
            self.searchFieldFormLists = self.feildtrackingForms;
          }
        }
      } catch (e) {
        console.log(e);
      }
    },

    undoSign() {
      var self = this;
      console.log("REFS00000", self.$refs.signaturePad);
      self.$refs.signaturePad[0].clearSignature();
    },

    onBegin() {
      this.$refs.signaturePad[0].resizeCanvas();
    },

    getImageAttachment(src) {
      if (src == undefined || src == "") {
        const demoImg = require("@/assets/demo.png");
        return demoImg;
      }
      return (
        this.$store.state.imagePath +
        src.insert(src.lastIndexOf("."), "_200x200")
      );
    },
    updateCheckBtn() {
      var lastPunch = this.userLastPunchs.sort(function compare(a, b) {
        return new Date(b.time) - new Date(a.time);
      })[0];
      if (lastPunch) {
        if (moment.utc().diff(moment.utc(lastPunch.time), "seconds") > 86400) {
          this.isCheckedIn = false;
          return;
        }
        if (lastPunch.punchType == "IN") {
          this.isCheckedIn = true;
          return;
        } else {
          this.isCheckedIn = false;
          return;
        }
      } else {
        this.isCheckedIn = false;
        return;
      }
    },
    async load() {
      const self = this;

      await this.updateTagAndLocation(
        this.$store.getters.getSelectedTagsAndLocations
      );

      this.fieldTrackingsDetails();
      this.getForms();

      this.getFieldtrackingForms().then(response => {
        if (response) {
          self.feildtrackingForms = response.body;

          self.searchFieldFormLists = self.feildtrackingForms;
        }
      });

      this.getShiftData();
      // this.baseLocationId = this.$store.state.userDetails.baseLocationId

      //Get present month count
      this.getPresentThisMonthCount();

      this.getUserPunchs();

      EventBus.$on("punch", state => {
        switch (state) {
          case "start":
            self.punchBar = true;
            break;

          case "cancel":
            self.punchBarText = "Punch Process Halted";
            setTimeout(() => {
              self.punchBar = false;
            }, 2000);
            break;

          case "stop":
            setTimeout(() => {
              self.punchBar = false;
            }, 2000);
            self.punchBarText = "Punch Process Complete";
            break;

          default:
            self.punchBarText = state;
            break;
        }
      });

      this.unsub = this.$store.subscribe((mutation, state) => {
        if (
          mutation.type === "setSelectedTags" ||
          mutation.type === "setMode" ||
          mutation.type === "setGroup"
        ) {
          const opts = {
            tags: _.map(
              _.filter(state.selectedTags, t => t.type == "tag"),
              "id"
            ),
            locations: _.map(
              _.filter(state.selectedTags, t => t.type == "location"),
              "id"
            ),
            mode: state.mode,
            group: state.group
          };
          this.updateTagAndLocation(opts);
        }
      });

      if (this.isMobile) {
        document.addEventListener(
          "deviceready",
          () => {
            self.checkFTState();
          },
          false
        );
      }
    },

    // get location details
    locationDetails() {
      this.$http
        .get(
          `${this.$store.state.endpoint}Locations?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
        )
        .then(
          response => {
            this.locationList = response.body;
            this.punchLocationId = response.body[0].id;
            // this.selectedTags.push(self.$store.state.userDetails.baseLocationId)
          },
          error => {
            // this.networkError = true
          }
        );
    },
    // search functionality for timeline card view
    searchContents() {
      const self = this;

      self.renderComponent = false;

      var re = new RegExp(self.search.toLowerCase(), "g"); //searched item
      _.each(self.timelinePunchDetails, f => {
        if (f.name.toLowerCase().match(re) || f.email.toLowerCase().match(re)) {
          f.visible = true;
        } else if (self.search == "") {
          f.visible = true;
        } else {
          f.visible = false;
        }
      });

      self.$nextTick(() => {
        self.renderComponent = true;
      });
    },
    zoom(url) {
      var fullPath = "";

      if (url == undefined) {
        fullPath = require("@/assets/demo.png");
        //return demoImg;
      } else {
        fullPath = this.$store.state.imagePath + url;
      }

      this.dialogZoom = true;
      this.selectedZoomImage = fullPath;
    },

    getCheckedInCount() {
      var c = 0;
      _.each(this.punchDetails, eachPunch => {
        if (eachPunch.punchType == "IN") {
          c++;
        }
      });
      return c;
    },
    getPresentThisMonthCount() {
      //Present this month
      const self = this;

      var startDate = moment()
        .startOf("month")
        .format();
      // console.log("Start Date", startDate);
      var endDate = moment().format();

      try {
        this.$http
          .get(
            `${
              this.$store.state.endpoint
            }attendances/presentByRange?startDate=${encodeURIComponent(
              startDate.toString()
            )}&endDate=${encodeURIComponent(endDate.toString())}`
          )
          .then(response => {
            self.presentThisMonthCount = response.body;
          });
      } catch (e) {
        console.log(e);
      }
    },

    getTotalPresentTodayCount() {
      var c = 0;
      _.each(this.punchDetails, eachPunch => {
        if (
          moment().isSame(
            moment(eachPunch.time).utcOffset(eachPunch.timezone.offset),
            "day"
          )
        ) {
          c++;
        }
      });
      return c;
    },

    /* getOnTimeCount(){
      var c = 0
      _.each(this.punchDetails,(eachPunch)=>{
        if(eachPunch.onTime) {
          c++
        }
      })
      return c
    },  */
    colorCalc(c) {
      return c === "OUT" ? "error" : "success";
    },

    canSee(what, role, options) {
      return canSee(this, what, role, options);
    },
    getImage(src, small) {
      if (src == undefined) {
        const demoImg = require("@/assets/demo.png");
        return demoImg;
      }

      if (small) {
        src = src.insert(src.lastIndexOf("."), "_200x200");
      }

      return this.$store.state.imagePath + src;
    },
    startFieldTracking() {
      const self = this;
      self.fieldTrackingEnabled = "loading";
      fieldTracking
        .start(this)
        .then(() => {
          self.checkFTState(this);
        })
        .catch(() => {
          self.fieldTrackingEnabled = false;
        });
    },
    stopFieldTracking() {
      const self = this;
      self.fieldTrackingEnabled = "loading";
      fieldTracking
        .stop(this)
        .then(() => {
          self.checkFTState();
        })
        .catch(() => {
          self.fieldTrackingEnabled = true;
        });
    },
    checkFTState() {
      const self = this;
      self.fieldTrackingEnabled = "loading";
      fieldTracking
        .enabled()
        .then(() => {
          self.fieldTrackingEnabled = true;
        })
        .catch(() => {
          self.fieldTrackingEnabled = false;
        });
    },
    getName(value) {
      const userData = this.allUsers;

      for (const o in userData) {
        if (userData[o].id == value) {
          return `${userData[o].firstName} ${userData[o].lastName}`;
        }
      }
    },
    checkIfRequired(value, answer) {
      if (value == true) {
        if (answer == "" || typeof answer == "undefined") {
          return "* Mandatory field";
        }
      }

      // if (value == false) {
      //   if (fieldType == "number") {
      //   if (answer != "" ){
      //       if (typeof answer == "undefined") {
      //           return "* Mandatory field";
      //         }

      //     }

      //   }
      // }

      return true;
    },

    formResponseView(val) {
      this.$http
        .get(`${this.$store.state.endpoint}formResponses/${val.formResponseId}`)
        .then(
          response => {
            this.responseForm = response.body;

            this.dialogFormResponse = true;
          },
          error => {
            console.log(error);
            // error callback
            this.$swal({
              type: "error",
              text: "Something went wrong. Try again later"
            });
          }
        );
    },

    showMapPointer(gps) {
      this.fieldItem.coordinates.lat = gps.lat;
      this.fieldItem.coordinates.lng = gps.lng;
    },
    timeFormat(value, formatType) {
      if (formatType == "hours") {
        return moment(value).format("h:mm:ss a");
      }
      if (formatType == "days") {
        return moment(value).format("dddd, MMMM Do YYYY");
      }
      return moment(value).format("mm:ss");
    },

    fieldTrackingsDetails() {
      const self = this;

      this.loading.fieldTrackingError = true;
      function getUserName(value) {
        const userData = self.allUsers;

        for (const o in userData) {
          if (userData[o].id == value) {
            return `${userData[o].firstName} ${userData[o].lastName}`;
          }
        }
      }

      this.loading.fieldTracking = true;
      this.$http
        .get(
          `${this.$store.state.endpoint}fieldTrackings?filter[where][userId]=${this.$store.state.userDetails.id}&filter[order]=time%20DESC&filter[limit]=5`
        )
        .then(
          response => {
            this.punchDetailsFieldTracking = [];
            this.loading.fieldTracking = false;
            this.loading.fieldTrackingError = false;
            const data = response.body;

            for (const m in data) {
              const time = moment(data[m].time)
                .utcOffset(data[m].timezone.offset)
                .format("llll");
              data[m].time = time;

              if (typeof data[m].address === "undefined") {
                data[m].address = {};
              }
            }

            if (data.length > 0) {
              self.punchDetailsFieldTracking = data;

              self.showMapPointer(data[0].gps);
            }
          },
          error => {
            this.loading.fieldTracking = false;
            this.loading.fieldTrackingError = false;
            this.networkError.fieldTracking = true;
            this.loading.lastPunch = false;
            this.networkError.lastPunch = true;
            this.networkError.fieldTrackingError = true;
            console.log(error);
          }
        );
    },

    async updateTagAndLocation(tags) {
      this.loading.latestCheckinError = true;

      if (typeof tags !== "undefined" && tags.hasOwnProperty("locations"))
        this.selectedTags = tags;

      const self = this;

      function getUserName(value) {
        const userData = self.allUsers;
        for (const o in userData) {
          if (userData[o].id == value) {
            return `${userData[o].firstName} ${userData[o].lastName}`;
          }
        }
      }

      function locationName(value) {
        for (const o in self.locationList) {
          if (self.locationList[o].id == value) {
            return self.locationList[o].name;
          }
        }
      }

      function shiftName(value) {
        const shiftData = self.shifts;
        for (const o in shiftData) {
          if (shiftData[o].id == value) {
            return shiftData[o].name;
          }
        }
      }

      try {
        var response = await this.$http.post(
          `${this.$store.state.endpoint}attendances/byFilter`,
          {
            tags: this.selectedTags.tags,
            locations: this.selectedTags.locations,
            groupId: this.selectedTags.group,
            mode: this.selectedTags.mode,
            // include: "supervisorDetails",
            showUnique: true,
            view: "reports"
          }
        );

        this.loading.latestCheckinError = false;
        var attendances = response.body.attendances;
        self.timelinePunchDetails = [];
        self.allUsers = response.body.users;

        for (var x in self.allUsers) {
          self.allUsers[x].visible = true;
          self.allUsers[
            x
          ].name = `${self.allUsers[x].firstName} ${self.allUsers[x].lastName}`;
          self.allUsers[x].profilePicture = self.allUsers[x].profilePicture;

          for (var y in attendances) {
            if (attendances[y]._id == self.allUsers[x].id) {
              self.allUsers[x].attendances = attendances[y];
              attendances[y].account = self.allUsers[x];
            }
          }
          self.timelinePunchDetails.push(self.allUsers[x]);
        }

        self.punchDetails = attendances;

        self.loading.lastPunch = false;
      } catch (err) {
        self.loading.latestCheckinError = false;
        self.networkError.latestCheckinError = true;
      }
    },
    punchColor(item) {
      return item.punchType == "IN" ? "green white--text" : "red white--text";
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5;
    },

    async captureImage() {
      const self = this;
      self.capturedImage = "";

      var capturedImage = await camera.getPicture(self, {
        destinationType: navigator.camera.DestinationType.DATA_URL,
        quality: 20,
        correctOrientation: true,
        targetWidth: 1024,
        cameraDirection: navigator.camera.Direction.FRONT
      });

      if (!capturedImage.includes("data:image")) {
        capturedImage = "data:image/png;base64," + capturedImage;
      }
      self.capturedImage = capturedImage;

      // self.getFileEntry(self.capturedImage)
    },

    getFileEntry(imgUri) {
      //const self = this

      return new Promise((resolve, reject) => {
        try {
          // console.log("inside this image", imgUri);
          //if(self.$mq == "mobile") {
          window.resolveLocalFileSystemURL(imgUri, function(fileEntry) {
            // console.log("got file: " + fileEntry);
            // console.log('cdvfile URI: ' + fileEntry.toInternalURL());
            // $('#imgPreview').attr("src", fileEntry.toInternalURL());
            var path = fileEntry.toURL();
            // console.log("file path  " + path);
            resolve(path);
          });
          // }
        } catch (e) {
          // console.log(e);
          reject(e);
        }
      });
    },

    handleFilesUpload(value, e, f) {
      // this.removeFile(value)
      var self = this;
      //  const refesData = self.userSelectedFormData[value].placeHolder;
      //   const uploadedPath = self.$refs;
      //    const uploadedFiles = uploadedPath[f][0].files;

      const file = e.target.files[0];
      // console.log("File is ", file);

      if (file.type == null || file.type == "" || file.type == undefined)
        return;

      if (file.size > 5000000) {
        e.preventDefault();
        self.$swal({ type: "warning", text: "File size is too big" });
        return;
      }

      self.attachmentName[value] = e.target.files[0].name;

      self.userSelectedFormData[value].answer = file;
      e.target.value = null;

      // Validation during file attachment
      //for (var x in self.userSelectedFormData) {
      // if (self.userSelectedFormData[x].fieldType == "attachment") {
    },

    removeFile(key) {
      this.userSelectedFormData[key].answer = "";
      this.attachmentName[key] = "";
    },
    async getForms() {
      this.forms = [];
      //this.loading.userFormError = true;
      const self = this;
      if (this.$store.state.userDetails.allowedForms) {
        var allowedForms = JSON.parse(
          JSON.stringify(this.$store.state.userDetails.allowedForms)
        );
      } else {
        var allowedForms = [];
      }

      //allowedForms.push(JSON.parse(JSON.stringify(this.$store.state.userDetails.fieldTrackingSettings.formId)));
      if (typeof allowedForms == "string") {
        allowedForms = [allowedForms];
      }

      const filter = { where: { id: { inq: allowedForms } } };
      const url = `${
        this.$store.state.endpoint
      }forms?filter=${encodeURIComponent(JSON.stringify(filter))}`;

      var response = await this.$http.get(url);

      self.loading.userFormError = false;

      self.forms = response.body;
      self.showUserForms = [];
      const formsData = self.forms;
      const checkinForms = self.$store.state.userDetails.allowedForms;

      for (const n in checkinForms) {
        for (const m in formsData) {
          if (checkinForms[n] == formsData[m].id) {
            self.showUserForms.push(formsData[m]);
          }
        }
      }

      self.searchFormLists = self.showUserForms;
    },
    async getFieldtrackingForms() {
      this.feildtrackingForms = [];
      const self = this;

      if (!this.$store.state.userDetails.fieldTrackingSettings.formId) {
        return;
      }

      const fieldForms = JSON.parse(
        JSON.stringify(
          this.$store.state.userDetails.fieldTrackingSettings.formId
        )
      );

      //  allowedForms.push(JSON.parse(JSON.stringify(this.$store.state.userDetails.fieldTrackingSettings.formId)));

      const filter = { where: { id: { inq: fieldForms } } };
      const url = `${
        this.$store.state.endpoint
      }forms?filter=${encodeURIComponent(JSON.stringify(filter))}`;

      return this.$http.get(url);
    },
    getShiftData() {
      this.shifts = [];

      this.$http
        .get(
          `${this.$store.state.endpoint}shifts?filter[where][companyId]=${this.$store.state.userDetails.companyId}`
        )
        .then(
          response => {
            this.shifts = response.body;
          },
          error => {
            console.log(error);
            // error callback
          }
        );
    },

    getAttachment(src) {
      return this.$store.state.attachmentPath + src;
    },

    getGreetingTime() {
      const currentTime = moment();
      if (!currentTime || !currentTime.isValid()) {
        return "Hello";
      }

      const splitAfternoon = 12; // 24hr time to split the afternoon
      const splitEvening = 17; // 24hr time to split the evening
      const currentHour = parseFloat(currentTime.format("HH"));

      if (currentHour >= splitAfternoon && currentHour <= splitEvening) {
        // Between 12 PM and 5PM
        return "Good Afternoon";
      }
      if (currentHour >= splitEvening) {
        // Between 5PM and Midnight
        return "Good Evening";
      }
      // Between dawn and noon
      return "Good Morning";
    },
    async getUserPunchs() {
      this.loading.lastPunch = true;

      this.userLastPunchs = [];

      const filter = {
        where: {
          outOfLocation: false,
          imageMissing: false,
          wifiMismatch: false,
          unapprovedManualPunch: false,
          flagged: false,
          userId: this.$store.state.userDetails.id
        },
        order: "time desc",
        limit: 5
      };

      try {
        var response = await this.$http.get(
          `${this.$store.state.endpoint}attendances?filter=${encodeURIComponent(
            JSON.stringify(filter)
          )}`
        );

        this.loading.lastPunch = false;
        this.userLastPunchs = _.filter(response.body, e => {
          return typeof e.originalLocation != "undefined";
        });
        this.updateCheckBtn();
        EventBus.$emit("updateAttendanceCount");
      } catch (error) {
        this.loading.lastPunch = false;

        this.networkError.lastPunch = true;
      }
    },
    getLocationName(value) {
      const locationData = this.locationList;
      for (const o in locationData) {
        if (locationData[o].id == value) {
          return locationData[o].name;
        }
      }
    },
    getLocationDesc(id) {
      const self = this;
      for (const o in self.locationList) {
        if (self.locationList[o].id == id) {
          if ("desc" in self.locationList[o]) {
            return self.locationList[o].desc;
          } else {
            return "";
          }
        }
      }
    },
    punch(punchType) {
      const userData = this.$store.state.userDetails;
      const locationIds = [];
      this.punchType = punchType;

      this.punchData = userData;

      if (userData.allowedLocations != undefined) {
        if (userData.allowedLocations.length > 1) {
          for (const m in userData.allowedLocations) {
            locationIds.push(userData.allowedLocations[m]);
            const unique = [...new Set(locationIds)];

            this.generateLocationList = unique;
            this.searchLocationLists = this.generateLocationList;
          }

          this.dialog = true;
        } else {
          this.performPunch(userData.allowedLocations[0], this.punchType);
        }
      } else {
        // Throw error no location
      }
    },
    stopPunch() {
      EventBus.$emit("punch", "cancel");
      this.snackbar = false;
    },

    async selectFile(e, index) {
      const self = this;
      if (device.platform.toLowerCase() == "browser") {
        this.$refs[e][0].click();
      } else {
        const data = await chooser.getFile();

        window.resolveLocalFileSystemURL(
          data.uri,
          function success(fileEntry) {
            fileEntry.file(
              function(file) {
                // console.log("File Entry", file);

                // self.attachmentName[index] = data.name;
                // self.userSelectedFormData[index].answer = file;

                var reader = new FileReader();
                reader.onloadend = function(e) {
                  var imgBlob = new Blob([new Uint8Array(reader.result)], {
                    type: this.type
                  });

                  /*  var file = new File([imgBlob], data.name, {
                type: data.mediaType
              }); */
                  // console.log("We have 2", imgBlob, this.name, this.index, this.type);

                  self.attachmentName[this.index] = this.name;
                  self.userSelectedFormData[this.index].answer = imgBlob;
                  //post formData here
                }.bind({ name: this.name, type: this.type, index: this.index });
                reader.readAsArrayBuffer(file);
              }.bind({ name: this.name, type: this.type, index: this.index })
            );
          }.bind({ name: data.name, type: data.mediaType, index: index })
        );
      }
    },

    selectedForm(item) {
      this.showAllFormsDialog = false;
      this.formHasAttachment = false;
      const self = this;

      const formStructure = item.formStructures;
      formStructure.forEach(data => {
        data.answer = "";
        if (data.fieldType == "attachment") {
          self.formHasAttachment = true;
        }
      });
      this.userSelectedFormData = [];
      // this.userSelectedFormData =
      this.userSelectedFormData = item.formStructures;
      this.selectFormID = item.id;

      this.dialogFormSelected = true;
      this.fieldTrackingFormsDialog = false;

      this.$refs.form.reset();
    },
    closeFormDialog() {
      var self = this;
      self.$refs.form.resetValidation();
      self.dialogFormSelected = false;
      self.userSelectedFormData = [];
      try {
        if (
          self.$refs.signaturePad != undefined &&
          self.$refs.signaturePad.length > 0
        ) {
          self.$refs.signaturePad[0].undoSignature();
        }
      } catch (e) {
        console.log(e);
      }
    },
    async formsDataPost(e) {
      const self = this;

      // Accumulate the responses in a  form data

      const myForm = new FormData();

      const responses = this.userSelectedFormData;

      const textresponses = [];

      var params = {
        formId: this.selectFormID,
        companyId: this.$store.state.userDetails.companyId,
        userId: this.$store.state.userDetails.id,
        response: textresponses
      };

      console.log("params", params);

      for (const m in responses) {
        //Validating Required fields
        if (responses[m].required) {
          if (responses[m].fieldType == "date") {
            if (!responses[m].answer) {
              return this.$swal({
                type: "warning",
                text: "Mandatory date is required"
              });
            }
          } else if (responses[m].fieldType == "attachmentSignature") {
            var dataSign = self.$refs.signaturePad[0].saveSignature();
            console.log("Sign ", self.$refs.signaturePad);
            if (dataSign.data == undefined) {
              return this.$swal({
                type: "warning",
                text: "Mandatory signature must be captured"
              });
            }
          } else if (responses[m].fieldType == "attachmentCapture") {
            if (self.capturedImage == "") {
              return this.$swal({
                type: "warning",
                text: "Mandatory image must be captured"
              });
            }
          } else if (responses[m].fieldType == "attachment") {
            if (responses[m].answer == "") {
              return this.$swal({
                type: "warning",
                text: "Mandatory file must be captured"
              });
            }
          } else if (responses[m].fieldType == "number") {
            if (typeof responses[m].answer == "undefined") {
              return this.$swal({
                type: "warning",
                text: "Only Number is allowed"
              });
            }
          } else if (
            typeof responses[m].answer == "string" &&
            responses[m].answer == ""
          ) {
            return this.$swal({
              type: "warning",
              text: "Mandatory field must be submitted"
            });
          } else if (
            typeof responses[m].answer == "object" &&
            Object.keys(responses[m].answer).length < 1
          ) {
            return this.$swal({
              type: "warning",
              text: "Mandatory field must be submitted"
            });
          }
        }

        if (responses[m].fieldType == "attachment") {
          if (device.platform.toLowerCase() == "browser") {
            myForm.append("file", responses[m].answer);
            //
          } else {
            /* var blob = new Blob([responses[m].answer.data], {
              type: responses[m].answer.mediaType
            });

            var file = new File([blob], responses[m].answer.name, {
              type: responses[m].answer.mediaType
            });  */
            myForm.append("file", responses[m].answer, self.attachmentName[m]);
          }

          responses[m].answer = self.attachmentName[m];
          textresponses.push(responses[m]);
        } else if (responses[m].fieldType == "attachmentSignature") {
          var dataSign = self.$refs.signaturePad[0].saveSignature();
          params.signature = dataSign.data;
          textresponses.push(responses[m]);
        } else if (responses[m].fieldType == "attachmentCapture") {
          params.imageCapture = self.capturedImage;
          textresponses.push(responses[m]);
        } else if (responses[m].fieldType == "date") {
          if (responses[m].required) {
            if (
              responses[m].answer == "" ||
              typeof responses[m].answer == "undefined"
            ) {
              self.$swal({ type: "warning", text: "Date field is required" });
              return;
            }
          }

          var dataField = {
            fieldLabel: responses[m].fieldLabel,
            fieldType: responses[m].fieldType,
            placeHolder: responses[m].placeHolder,
            required: responses[m].required
          };

          if (responses[m].answer != "") {
            dataField.answer = moment(responses[m].answer).format();
          } else {
            dataField.answer = "";
          }

          textresponses.push(dataField);
        } else {
          textresponses.push(responses[m]);
        }
      }

      params.response = textresponses;

      if (self.isFieldTrackingForm == true) {
        params.fieldTrackingId = self.trackingResponseData.id;
      }
      myForm.append("response", JSON.stringify(params));

      if (!self.$refs.form.validate()) {
        alert("validation error");
      }
      this.afterSubmit = true;

      this.$http
        .post(`${this.$store.state.endpoint}formResponses/respond`, myForm, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: this.$store.state.user.id
          }
        })
        .then(function(res) {
          console.log(res);

          self.$refs.form.resetValidation();
          self.$refs.form.reset();
          self.capturedImage = "";

          if (self.isFieldTrackingForm == true) {
            self.isFieldTrackingForm = false;
            self.fieldTrackingsDetails();
          }

          self.$swal({
            type: "success",
            text: "Succesfully submitted"
          });

          self.afterSubmit = false;
          self.closeFormDialog();
        })
        .catch(function(error) {
          // console.log(error);
          self.$refs.form.reset();
          self.$refs.form.resetValidation();
          self.afterSubmit = false;

          self.$swal({
            type: "error",
            title: "Oops",
            text: "Sorry, try again later."
          });
          self.closeFormDialog();
        });
    },
    markLocation() {
      var self = this;

      const punchObj = {
        userId: this.$store.state.userDetails.id,
        fieldTrackingSettings: this.$store.state.userDetails
          .fieldTrackingSettings,
        mode: "ft"
      };

      // TODO check if a form is present and then patch that response

      punch(this, punchObj).then(
        function(response) {
          if (
            JSON.parse(
              JSON.stringify(
                self.$store.state.userDetails.fieldTrackingSettings.formId
              )
            ) != ""
          ) {
            const assignedForms = JSON.parse(
              JSON.stringify(self.feildtrackingForms)
            );
            // self.selectedForm(assignedForms[m]);
            self.isFieldTrackingForm = true;
            self.trackingResponseData = response;

            // self.fieldTrackingFormsDialog = true;
            if (assignedForms.length > 0) {
              self.fieldTrackingFormsDialog = true;
            }
          }

          self.fieldTrackingsDetails();

          self.$swal({
            type: "success",
            title: "Field Tracking Done!",
            text: "Your location was marked"
          });
        },
        error => {
          self.$swal({
            type: "error",
            title: "Oops...",
            text: "Something went wrong!"
          });
        }
      );
    },

    getFileEntryCordova(data) {
      window.requestFileSystem(
        LocalFileSystem.PERSISTENT,
        0,
        function(fs) {
          console.log("file system open: " + fs.name);
          fs.root.getFile(
            file.uri,
            { create: false, exclusive: false },
            function(fileEntry) {
              fileEntry.file(
                function(file) {
                  /*  var reader = new FileReader();
                    reader.onloadend = function() {
                        // Create a blob based on the FileReader "result", which we asked to be retrieved as an ArrayBuffer
                        var blob = new Blob([new Uint8Array(this.result)], { type: data.mediaType });
                        console.log(blob)
                        
                    };
                    // Read the file as an ArrayBuffer
                    reader.readAsArrayBuffer(file); */
                  resolve(file);
                },
                function(err) {
                  console.error("error getting fileentry file!" + err);
                }
              );
            },
            function(err) {
              console.error("error getting file! " + err);
            }
          );
        },
        function(err) {
          console.error("error getting persistent fs! " + err);
        }
      );
    },

    performPunch(item, punchType) {
      this.dialog = false;
      const checkinData = this.punchData;
      const self = this;

      if (!punchType) punchType = this.punchType;

      const punchObj = {
        userId: checkinData.id,
        locationId: item,
        securitySettings: checkinData.securitySettings,
        punchType
      };

      function autoRealTimeTracking(vm, type) {
        if (vm.$mq == "mobile") {
          if (
            vm.$store.getters.userDetails.realtimeFieldTrackingSettings
              .enabled == true &&
            vm.$store.getters.userDetails.realtimeFieldTrackingSettings
              .autoStart == true
          ) {
            if (type == "IN") {
              vm.startFieldTracking();
            } else {
              vm.stopFieldTracking();
            }
          }
        }
      }

      punch(this, punchObj).then(
        response => {
          EventBus.$emit("updateAttendanceCount");

          var flagMessage = [];

          if (response.flagged) {
            if (response.outOfLocation) {
              var type = "warning";
              flagMessage.push("Location mismatch");
            }

            if (response.imageMissing) {
              var type = "warning";
              flagMessage.push("Image mismatch");
            }

            if (response.wifiMismatch) {
              var type = "warning";
              flagMessage.push("Wifi mismatch");
            }

            if (response.deviceMismatch) {
              var type = "warning";
              flagMessage.push("Device mismatch");
            }

            text = `The attendance was flagged due to ${flagMessage.join(
              ", "
            )}. Your supervisor has been notified and will approve/reject the punch`;
          } else {
            var text = "Your attendance was recorded succesfully";
            var type = "success";
          }

          autoRealTimeTracking(self, punchType);

          self.$swal({
            type: type,
            title: "Attendance Sent",
            text: text
          });

          self.getUserPunchs();
          self.getPresentThisMonthCount();
          self.updateTagAndLocation();
        },
        error => {
          console.log(error);
          self.$swal({
            type: "error",
            title: "Oops...",
            text: "Something went wrong!"
          });
          self.dialog = false;

          EventBus.$emit("punch", "stop");
        }
      );
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mx-datepicker-popup {
  position: initial !important;
}
.custom_action {
  width: 120px;
  color: #fff !important;
  letter-spacing: 0.5px;
}

h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

div.file-listing {
  width: 200px;
}

span.remove-file {
  color: red;
  cursor: pointer;
  float: right;
}

.timeline-block {
  display: -ms-flexbox;
  display: flex;
}

.avtrCust {
  color: white;
  font-weight: 600;
}
.success {
  font-size: 14px !important;
}
.remove_attachment {
  font-size: 13px;
  text-transform: uppercase;
  font-weight: bold;
  letter-spacing: 0.5px;
  margin-top: 7px;
}
h6 {
  font-size: 14px;
}
.attachment_card {
  padding: 15px;
  background-color: #f6f6f6;
  box-shadow: none !important;
  color: #1f1f1f;
}

.chartNew {
  width: 100% !important;
  height: 100px !important;
}

.v-list__tile__title,
.v-list__tile__sub-title {
  white-space: inherit !important;
  overflow: hidden;
  text-overflow: ellipsis;
  /* -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1); */
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  width: 100%;
}
.form_response_h4 {
  font-size: 14px;
  color: #292929;
}
.form_response_h3 {
  font-size: 15px;
  font-weight: 500;
  color: #292929;
  word-wrap: break-all !important;
}
.form_response_title_h3 {
  font-size: 18px;
  letter-spacing: 0.5px;
  font-weight: 600;
  color: #292929;
  word-wrap: break-all !important;
}

.v-speed-dial--right {
  right: 42px;
}
.v-timeline-item__body {
  text-align: center !important;
}

.v-btn--example {
  bottom: 0;
  /*position: absolute; */
  margin: 0 90px 16px 16px;
}
</style>
